export default {
  PAUSE_TRACKING_REASONS_REPOSITORY: Symbol.for('PAUSE_TRACKING_REASONS_REPOSITORY'),
  GET_PAUSE_TRACKING_REASONS_QUERY: Symbol.for('GET_PAUSE_TRACKING_REASONS_QUERY'),
  PAUSE_TRACKING_REASONS_STATE_MANAGER: Symbol.for('PAUSE_TRACKING_REASONS_STATE_MANAGER'),
};
